import React from 'react';

import {
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import classes from '../../css/getCSS';


const filterPanel = (props) => {
  return (
    <ExpansionPanel
      className={classes.filterPanel}
      expanded={props.expanded}
      onChange={() => props.handleChange(props.panel)}
      style={{ marginBottom: '10px' }}
    >
      <ExpansionPanelSummary
        classes={{
          root: classes.panelTitleSummary,
          content: classes.panelTitleSummaryContent,
          expandIcon: classes.panelExpandIcon,
        }}
        expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
      >
        <Typography variant="subheading" style={{ fontSize: '18px' }}>{props.title}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.panelDetails}>
        {props.children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default filterPanel;



// WEBPACK FOOTER //
// ./src/search/components/filterPanel.js